import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  container: {
    position: 'sticky',
    top: 54,
    zIndex: 10,
  },
  errorMessageList: {
    listStylePosition: 'inside',
  },
});

export default styles;
